<apple-pay-button buttonstyle="black"
                  type="plain"
                  locale="en-US"
                  (click)="onClick($event)"
                  #buttonRef></apple-pay-button>
<result [status]="applePayAvailableStatus" />